// extracted by mini-css-extract-plugin
module.exports = {"label":"index_label__wNMsK","container":"index_container__3Q_IW","selectBtn":"index_selectBtn__z4JaY","item":"index_item__ZOCby","select":"index_select__XwrZu"};